import React, {useState} from 'react';
import {
  accTextBox,
  contentContainer,
  continueBtn,
  emailSignUp,
  forgotPwBox,
  forgotPwTxt,
  textFieldSignIn,
} from './LandingViewStyles';
import {Box, Button} from '@mui/material';
import {CustomSlider} from '../../../components/common/Animation/CustomSlider';
import {secondaryTitle} from '../Registration/RegistrationStyles';
import {PasswordInput} from '../../../components/common/PasswordInput/PasswordInput';
import {useNavigate} from 'react-router-dom';
import {usePopUp} from '../../../hooks/usePopUp';
import {app, signInWithEmailAndPassword} from '../../../providers/Accounts';
import {checkOnboardingStatus} from '../../../providers/api/profile';
import {pageGuards} from '../../../routes/guards/PublicRoute';
import {PopUp} from '../../../components/common/PopUp/PopUp';
import {digiStaffLogo} from '../../../components/common/Image/Image';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

interface PasswordValues {
  setShowPasswordSection: (value: boolean) => void;
  onBackToEmail: () => void;
}

const PasswordSection: React.FC<PasswordValues> = ({
  setShowPasswordSection,
  onBackToEmail,
}) => {
  const [passwordValues, setPasswordValues] = useState({
    password: '',
    showPassword: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {handlePopUp, popUp, closePopUp, status, message} = usePopUp();
  const email = localStorage.getItem('email');

  const fullyOnboard = 10;
  const pwRequiredLength = 8;

  const handleChange =
    (prop: string) => (event: React.ChangeEvent<HTMLInputElement>) =>
      setPasswordValues({...passwordValues, [prop]: event.target.value});

  const redirectUser = async () => {
    try {
      const onboardingStatus = await checkOnboardingStatus();
      // Redirect user to last completed registration stage if not yet fully registered
      if (onboardingStatus < fullyOnboard) {
        const redirectToPage = pageGuards.find(
          (p: any) => p.page === onboardingStatus.toString()
        );

        navigate(`${redirectToPage.url}`);
      } else {
        navigate('/agency/select');
      }
    } catch (err) {
      console.log(err);
      console.log(err);
    }
  };

  const login = async () => {
    const {password} = passwordValues;

    if (!email) {
      handlePopUp(
        'error',
        'Missing email address. Redirecting you to input email address'
      );
      setTimeout(() => {
        navigate('/');
      }, 1000);
      return;
    }

    if (password.length < pwRequiredLength) {
      handlePopUp('error', 'Password incorrect');
      return;
    }

    setIsLoading(true);
    try {
      await signInWithEmailAndPassword(app, email, password);
      await redirectUser();
    } catch (error: any) {
      if (
        error?.err?.name === 'UserNotFoundException' ||
        error?.err?.name === 'NotAuthorizedException' ||
        error.code === 'DS_USER_INVALID_CREDS'
      ) {
        handlePopUp('error', 'Username or password incorrect!');
      } else {
        console.log(error);
        console.log(error);
        handlePopUp('error', 'Unable to login, please contact admin');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = async (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      await login();
    }
  };

  const forgotPw = () => navigate('/password-recovery');

  const handleBackToLogin = () => {
    setPasswordValues({
      password: '',
      showPassword: false,
    });
    setShowPasswordSection(false);
    onBackToEmail();
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Box sx={contentContainer}>
          {/* <Box sx={iframeBox}> */}
          <Box
            component="img"
            src={digiStaffLogo}
            sx={{
              height: 'auto',
              width: '100%',
              objectFit: 'contain',
              display: {xs: 'block', md: 'none'},
            }}
          />
          {/* </Box> */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',

              mb: 3,
            }}
          >
            <Box sx={accTextBox}>Password</Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              // background: 'pink',
            }}
          >
            <Box sx={{mb: 5}}>
              <CustomSlider direction="left" fadeIn={300}>
                <Box sx={secondaryTitle}>
                  Login with your Password to continue
                </Box>
              </CustomSlider>
            </Box>

            <Box sx={emailSignUp}>
              <CustomSlider direction="left" fadeIn={350}>
                <Box sx={{width: '100%', pb: 3}}>
                  <Box sx={{pb: 0.4}}>Password</Box>
                  <PasswordInput
                    id="password-field"
                    autoFocus
                    type={passwordValues.showPassword}
                    style={textFieldSignIn}
                    name="password"
                    onChange={handleChange('password')}
                    value={passwordValues.password}
                    onKeyDown={handleKeyDown}
                    onClickIcon={() =>
                      setPasswordValues({
                        ...passwordValues,
                        showPassword: !passwordValues.showPassword,
                      })
                    }
                  />
                </Box>
              </CustomSlider>
              <CustomSlider direction="left" fadeIn={400}>
                <Box sx={{}}>
                  <Button
                    variant="outlined"
                    sx={{...continueBtn}}
                    onPointerUp={login}
                    id="login-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Logging in...' : 'Login'}
                  </Button>
                </Box>
              </CustomSlider>
              <CustomSlider direction="left" fadeIn={500}>
                <Box sx={forgotPwBox}>
                  <Box sx={forgotPwTxt} onPointerUp={forgotPw}>
                    Forgot password?
                  </Box>
                </Box>
              </CustomSlider>
              <CustomSlider direction="left" fadeIn={600}>
                <Box
                  sx={{
                    display: {xs: 'block', md: 'none'},
                    width: '100%',
                    background: 'pink',
                  }}
                >
                  <Button
                    variant="outlined"
                    startIcon={<KeyboardBackspaceIcon />}
                    fullWidth
                    onClick={handleBackToLogin}
                  >
                    Back to Email
                  </Button>
                </Box>
              </CustomSlider>
            </Box>
          </Box>
        </Box>
      </Box>
      <PopUp
        isOpen={popUp}
        onClose={closePopUp}
        status={status}
        message={message}
      />
    </>
  );
};

export default PasswordSection;
